import { render, staticRenderFns } from "./Txgl.vue?vue&type=template&id=e0c78878&scoped=true&"
import script from "./Txgl.vue?vue&type=script&lang=js&"
export * from "./Txgl.vue?vue&type=script&lang=js&"
import style0 from "./Txgl.vue?vue&type=style&index=0&id=e0c78878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c78878",
  null
  
)

export default component.exports